import $ from 'jquery';

/**
 * Defines the className of the dot button
 * @type {string}
 */
export const DOT_CLASS = 'image-carousel__dot-button';

/**
 * Allows us to customize the "dot buttons"
 * @param {jQuery} $slides - slick slides (from slick)
 * @param {number} i - iterator, used to select current slide from $slides
 * @see DEFAULT_OPTIONS
 * @return {jQuery} "dot button"
 */
export default function customPaging({ $slides }, i) {
  const $a = $(`<button class="${DOT_CLASS}" data-role="none" aria-selected="${i === 0}">slide ${i + 1}</button>`);

  return $a.on('click', e => e.preventDefault());
}



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/slick/custom-paging.js